import { finalize } from 'rxjs';
import { AbstractDatasource } from 'src/app/modules/shared/components/be-paginated-table/abstract.datasource';
import {
  IEmployerSearchRequest
} from 'src/app/modules/shared/models/operation.model';
import { SpinnerService } from 'src/app/services/spinner.service';
import { SearchService } from '../search/search.service';

export class EmployerSearchDatasource extends AbstractDatasource<any, any> {
  constructor(
    private searchService: SearchService,
    private spinnerService: SpinnerService
  ) {
    super();
  }

  search(body: IEmployerSearchRequest) {
    this.loadingSubject.next(true);
    this.spinnerService.show();
    return this.searchService.getEmployer(body).pipe(
      finalize(() => {
        this.spinnerService.hide();
        this.loadingSubject.next(false);
      })
    );
  }

  disconnect() {
    this.resultSubject.next([]);
  }
}
